"use client";
import FirebaseNotificationSubscriber from "./FirebaseNotification";

export default function PushNotificationSubscriber() {
  return (
    <>
      <FirebaseNotificationSubscriber />
    </>
  );
}

// Helper
function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
